import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;


export default class User {

  static endpoints = {
    index: `${baseUrl}/user`,
  };

  static paginator = {
    offerClaims      : (data)=> axios.get(`${this.endpoints.index}/paginator/offers`, {params: data}).then((response)=> response.data.offers.items),
    surveyClaims     : (data)=> axios.get(`${this.endpoints.index}/paginator/surveys`, {params: data}).then((response)=> response.data.surveys.items),
    checkIns         : (data)=> axios.get(`${this.endpoints.index}/paginator/check-ins`, {params: data}).then((response)=> response.data.checkIns.items),
    promotionsClaims : (data)=> axios.get(`${this.endpoints.index}/paginator/promotions`, {params: data}).then((response)=> response.data.promotions.items),
    referrals        : (data)=> axios.get(`${this.endpoints.index}/paginator/referrals`, {params: data}).then((response)=> response.data.referrals.items),
    referralRewards  : (data)=> axios.get(`${this.endpoints.index}/paginator/referral-rewards`, {params: data}).then((response)=> response.data.rewards.items),
    gamesRewards     : (data)=> axios.get(`${this.endpoints.index}/paginator/games`, {params: data}).then((response)=> response.data.rewards.items),
    gamesTransactions: (data)=> axios.get(`${this.endpoints.index}/paginator/games-transactions`, {params: data}).then((response)=> response.data.transactions.items),
    bonus            : (data)=> axios.get(`${this.endpoints.index}/paginator/bonus`, {params: data}).then((response)=> response.data.rewards.items),
    tasksClaims      : (data)=> axios.get(`${this.endpoints.index}/paginator/tasks`, {params: data}).then((response)=> response.data.tasks.items),
    contests         : (data)=> axios.get(`${this.endpoints.index}/paginator/contests`, {params: data}).then((response)=> response.data.contests.items),
    tokensClaims     : (data)=> axios.get(`${this.endpoints.index}/paginator/tokens`, {params: data}).then((response)=> response.data.tokens.items),
    betsClaims       : (data)=> axios.get(`${this.endpoints.index}/paginator/bets`, {params: data}).then((response)=> response.data.bets.items),
    cashbacksClaims  : (data)=> axios.get(`${this.endpoints.index}/paginator/cashbacks`, {params: data}).then((response)=> response.data.cashbacks.items),
    gamesRecords     : (data)=> axios.get(`${this.endpoints.index}/paginator/games-records`, {params: data}).then((response)=> response.data.gamesRecords.items),
  };

  static account() {
    return axios.get(`${this.endpoints.index}/account`).then((response)=> response.data);
  };

  static avatars() {
    return axios.get(`${this.endpoints.index}/profile/avatars`).then((response)=> response.data.icons);
  };

  static profile() {
    return axios.get(`${this.endpoints.index}/profile`).then((response)=> response.data.profile);
  };

  static setAvatar(avatar) {
    return axios.post(`${this.endpoints.index}/profile/avatars`, {avatar}).then((response)=> response.data.avatar);
  };

  static telegramProfile() {
    return axios.get(`${this.endpoints.index}/telegram-profile`).then((response)=> response.data.telegramProfile);
  };

  static getTickets() {
    return axios.get(`${this.endpoints.index}/tickets`).then((response)=> response.data.tickets);
  };

  static setGamesKey(data, gameId) {
    return axios.post(`${this.endpoints.index}/games-key/${gameId}`, data).then((response)=> response.data);
  };

  static updateProfile(data) {
    return axios.post(`${this.endpoints.index}/profile`, data).then((response)=> response.data.profile);
  };

  static updateTelegramProfile(data) {
    return axios.post(`${this.endpoints.index}/telegram-profile`, data).then((response)=> response.data.telegramProfile);
  };

  static referrals() {
    return axios.get(`${this.endpoints.index}/referrals`).then((response)=> response.data.referrals);
  };

  static history() {
    return axios.get(`${this.endpoints.index}/reward-history`).then((response)=> response.data);
  };

  static surveyBans() {
    return axios.get(`${this.endpoints.index}/survey-bans`).then((response)=> response.data.networkIds);
  };

  static checklist() {
    return axios.get(`${this.endpoints.index}/checklist`).then((response)=> response.data.checklist);
  };

  static completeChecklist() {
    return axios.post(`${this.endpoints.index}/checklist/completed`).then((response)=> response.data.reward);
  };

  static registerPushSubscription(data) {
    return axios.post(`${this.endpoints.index}/push-subscription/register`, data).then((response)=> response.data);
  };


  static getActivity() {
    return axios.get(`${this.endpoints.index}/activity`).then((response)=> response.data.activity);
  };

  static clearActivity() {
    return axios.delete(`${this.endpoints.index}/activity`).then((response)=> response.data.removed);
  };

  static getDailyGoals() {
    return axios.get(`${this.endpoints.index}/daily-goals`).then((response)=> response.data.dailyGoals);
  };

}


